module.exports = __webpack_public_path__ + "static/media/planning-for-success-large@2x.1ffac6c1.png";